import { generalEnv } from '@nx-frontend/shared/env';

const PRICING_WS_BANNER_DEFAULT = 'menu_upgrade_to_pro';
/**
 * Returns admin url with automatic authentication aka cross domain cookie sharing
 * @param orgId
 * @param workspaceId
 * @param postfix
 * @returns
 */
export function getAdminClientUrl(
  adminClientUrl: string,
  orgId?: string | undefined,
  workspaceId?: string | undefined,
  postfix = '',
  exactPath = false
): string {
  const clientPath = getAdminClientPath(orgId, workspaceId, postfix, exactPath);
  const { host: adminDomain } = new URL(adminClientUrl);
  return `/auth/open-org/private?td=${adminDomain}&success=${clientPath}`;
}

/**
 * Returns admin client url without automatic authentication
 * @param orgId
 * @param workspaceId
 * @param postfix
 */
export function getAdminClientDirectUrl(
  adminClientUrl: string,
  orgId?: string | undefined,
  workspaceId?: string | undefined,
  postfix = '',
  exactPath = false
): string {
  const clientPath = getAdminClientPath(orgId, workspaceId, postfix, exactPath);
  return adminClientUrl + clientPath;
}

/**
 * Returns admin client url path based on parameters
 * @param orgId
 * @param workspaceId
 * @param postfix
 */
export function getAdminClientPath(
  orgId?: string | undefined,
  workspaceId?: string | undefined,
  postfix: string | '' = '',
  exactPath = false
): string {
  let clientPath = '';
  if (exactPath) {
    return postfix;
  }
  if (orgId) {
    clientPath = `/org/${orgId}`;
    if (workspaceId) {
      clientPath += `/ws/${workspaceId}`;
    }
  } else {
    clientPath = '/';
  }
  clientPath += postfix;
  return clientPath;
}

export function getPricingClientUrl(orgId: string, wsBanner?: string | undefined): string {
  return `https://${generalEnv.nimbusDomain}/pricing/?ws_banner=${
    wsBanner ? wsBanner : PRICING_WS_BANNER_DEFAULT
  }&orgId=${orgId}`;
}

export function getGuideClientUrl(pageName: string): string {
  return `https://${generalEnv.nimbusDomain}/guides/${pageName}`;
}
